import React, { useEffect, useRef, useState, lazy, Suspense  } from 'react';
import GlobalStyle from './globalStyles';
import './App.css';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { addItem, getItemByKey, initDB, removeItemByKey } from "./utils/indexedDB";
import TagManager from 'react-gtm-module';
import { sendEventReturn } from "./api/nativeBridge";
import otherApi from "./api/gatewayApi/other";
import { decrypt, generateMCP_TR_KEY } from "./api/authFunctions";
import paymentApi from "./api/gatewayApi/payment";
import { settingApi } from "./api/gatewayApi/settingAndTerms";
import useDevicePlatform from "./hooks/useDevicePlatform";
import ScrollToTop from "./provider/ScrollToTop";
import { datadogRum } from "@datadog/browser-rum";
import { ENVIROMENT, fetchAuth } from "./api/api";
import { callCheckPassword, handleSendEvent } from "./utils/helper";
import { idbUtil } from './utils/idbUtils';
import { idbHelper } from './utils/idbHelper';
import { FeatureFlag } from './utils/features';


import FOHomeBenefitPopup from './pages/Home/FOHomeBenefitPopup';


(window as any).digitalData = {};

TagManager.initialize({
    gtmId: 'GTM-MQRHVPWZ'
})

if (ENVIROMENT === 'prod') {
    datadogRum.init({
        applicationId: '65a493bf-57f9-42de-81d4-4f3b7a33ee0b',
        clientToken: 'pub0385564d3106780e4a942c99249beb85',
        site: 'datadoghq.com',
        // service: 'my-web-application',
        env: ENVIROMENT,
        // version: '1.0.0',
        sessionSampleRate: 0,//10,//10->0
        sessionReplaySampleRate: 0,//100,//100->0
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        enablePrivacyForActionName: true,
    });
}


const App: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [myLgIdPopup, setMyLgIdPopup] = useState(false);
    const [passwordErrorPopup, setPasswordErrorPopup] = useState({ show: false, message: '' });
    const [mobilePayRequestPopup, setMobilePayRequestPopup] = useState({
        show: false,
        payShopName: '',
        payMoney: '',
        otpId: ''
    });
    const webPlatformInfo = useDevicePlatform();

    const fetchUserInfo = async () => {
        await sendEventReturn('GET_MEMBER_ID', {});
        await sendEventReturn('GET_AD_AGREE', {});
        await sendEventReturn('DEVICE_SYSTEM_INFO', {});

    };

    const timeFormat = (date: Date): string => {
        const currentTime = date.toISOString();
        const offset = new Date().getTimezoneOffset() * -1; // Timezone offset in minutes (KST is UTC+9)
        const offsetHours = Math.floor(offset / 60);
        const offsetMinutes = offset % 60;

        const formattedOffset = `${offsetHours >= 0 ? "+" : "-"}${String(Math.abs(offsetHours)).padStart(2, "0")}:${String(offsetMinutes).padStart(2, "0")}`;

        return `${currentTime.split(".")[0]}${formattedOffset}`;
    }

    // 모든 공백 제거 함수
    const removeSpaces = (str: string): string =>{
        return str.replace(/\s+/g, '');
    }
    const getTelcoCode = (tel_info: string): string => {
        //return tel_info === "LG U+" ? "L" : "O";
        return removeSpaces(tel_info) === "LGU+" ? "L" : "O";
    }

    console.log(`api start in ${process.env.NODE_ENV} env and ${process.env.REACT_APP_ENV_MODE} MODE`)
    useEffect(() => {
        (window as any).onExecuteCallback = async (jsonString: string) => {
            try {
                console.log(jsonString)
                jsonString = jsonString.replace(/\n/g, '\\n');
                const jsonObject = JSON.parse(jsonString);
                console.log('web : Received object from native:', jsonObject);

                if (jsonObject.type === 'DEVICE_SYSTEM_INFO') {
                    const deviceInfo = jsonObject.param
                    console.log(deviceInfo)
                    
                    await addItem('ctn', deviceInfo.ctn_info)
                    const first_loading = await getItemByKey('first_loading');
                    if (first_loading === undefined || first_loading === null) {
                        await addItem('first_loading', deviceInfo.first_loading)
                    }
                    await addItem('platform', deviceInfo.os_info === 'AND' ? 'AOS' : 'IOS')
                    if (deviceInfo.os_info === 'AND') {
                        const telcoCode = getTelcoCode(deviceInfo.tel_info)
                        await idbHelper.setTelcoCode(telcoCode);
                    }
                    await addItem('osVersion', deviceInfo.os_version)
                    await addItem('appVersion', deviceInfo.version_info)
                    await addItem('model', deviceInfo.dev_model);
                    await addItem('adid', deviceInfo.adid)

                }

                if (jsonObject.type === 'GET_MEMBER_ID') {
                    const data = jsonObject.param
                    console.log('web : memberId:', data.memberId);
                    if (data.memberId) await addItem('memberId', data.memberId)
                    else await addItem('memberId', '')
                }

                if (jsonObject.type === 'SET_APP_LOCK') {
                    const data = jsonObject.param
                }

                if (jsonObject.type === 'SET_BIO_AUTH') {
                    const data = jsonObject.param
                }

                if (jsonObject.type === 'GET_BIO_AUTH') {
                    const data = jsonObject.param
                }

                if (jsonObject.type === 'GET_APP_LOCK') {
                    const data = jsonObject.param
                }

                if (jsonObject.type === 'INITIAL_LOADING_FINISHED') {
                    const data = jsonObject.param
                    console.log('web : LOADING_FINISHED:', data);
                    await fetchUserInfo();
                    // 앱 첫 구동시 바코드 정보 삭제
                    //await removeItemByKey('barcode');
                    //await removeItemByKey('barcodeTime');
                    
                    await idbUtil.setLatestAppStartTime();
                    await idbUtil.delLatestNavigateTabTime();
                }

                if (jsonObject.param.action === 'keypress' && jsonObject.param.detail === 'back') {
                    console.log('web : back key pressed');

                    const event = new CustomEvent('keypressBack', { detail: {} });
                    window.dispatchEvent(event)

                    navigate(-1)
                }

                if (jsonObject.type === 'GET_AD_AGREE') {
                    const data = jsonObject.param
                    console.log('web : GET_AD_AGREE:', data);
                    if (data.agree) {
                        await idbHelper.setAdAgreeYn(data.agree === true ? 'Y' : 'N');
                    }
                }

                if (jsonObject.type === 'SET_PASSWORD') {
                    const data = jsonObject.param
                    const resultType = data.result
                    if (resultType === "00") {
                        const telcoCode = await getItemByKey('telcoCode');
                        if (telcoCode === 'L') {
                            try {
                                const lockDisable = await paymentApi.setLockDisable({}, 'v1');
                                if (lockDisable.header.resultCode === "0000") {
                                    const paySeq = await paymentApi.getPaySeq('v1')
                                    if (paySeq.header.resultCode === "0000") {
                                        const encSeq = paySeq.body.encSeq
                                        const postPassword = await paymentApi.postPassword({
                                            encSeq: encSeq,
                                            passwordSha: '',
                                            newPasswordSha: data.password
                                        }, 'v1')
                                        if (postPassword.header.resultCode === "0000") {
                                            await sendEventReturn("SAVE_PASSWORD", { password: data.password })
                                        } else {
                                            setPasswordErrorPopup({
                                                message: postPassword.header.resultCode + postPassword.header.message,
                                                show: true
                                            })
                                            await sendEventReturn("SAVE_PASSWORD", { password: '' })
                                        }
                                    } else {
                                        setPasswordErrorPopup({
                                            message: paySeq.header.resultCode + paySeq.header.message,
                                            show: true
                                        })
                                        await sendEventReturn("SAVE_PASSWORD", { password: '' })
                                    }
                                } else {
                                    setPasswordErrorPopup({
                                        message: lockDisable.header.resultCode + lockDisable.header.message,
                                        show: true
                                    })
                                    await sendEventReturn("SAVE_PASSWORD", { password: '' })
                                }
                            } catch (error) {
                                await sendEventReturn("SAVE_PASSWORD", { password: '' })
                                console.error("SET_PASSWORD error:", error);
                            }
                        } else {
                            //타사
                            await sendEventReturn("SAVE_PASSWORD", { password: data.password })
                        }
                    }
                }

                if (jsonObject.type === 'CHANGE_PASSWORD') {
                    const data = jsonObject.param
                    const resultType = data.result
                    if (resultType === "00") {
                        const telcoCode = await getItemByKey('telcoCode');
                        if (telcoCode === 'L') {
                            try {
                                if (!data.prePassword || data.prePassword === '0') {
                                    const lockDisable = await paymentApi.setLockDisable({}, 'v1');
                                }
                                const paySeq = await paymentApi.getPaySeq('v1')
                                if (paySeq.header.resultCode === "0000") {
                                    const encSeq = paySeq.body.encSeq
                                    const postPassword = await paymentApi.postPassword({
                                        encSeq: encSeq,
                                        passwordSha: data.prePassword,
                                        newPasswordSha: data.password
                                    }, 'v1')
                                    if (postPassword.header.resultCode === "0000") {
                                        await sendEventReturn("SAVE_PASSWORD", { password: data.password })
                                    } else {
                                        setPasswordErrorPopup({
                                            message: postPassword.header.resultCode + postPassword.header.message,
                                            show: true
                                        })
                                        await sendEventReturn("SAVE_PASSWORD", { password: "" })
                                    }
                                } else {
                                    setPasswordErrorPopup({
                                        message: paySeq.header.resultCode + paySeq.header.message,
                                        show: true
                                    })
                                    await sendEventReturn("SAVE_PASSWORD", { password: "" })
                                }
                            } catch (error) {
                                await sendEventReturn("SAVE_PASSWORD", { password: "" })
                                console.log("CHANGE_PASSWORD error:", error)
                            }
                        } else {
                            await sendEventReturn("SAVE_PASSWORD", { password: data.password })
                        }
                        navigate(-1)

                    }
                }


                if (jsonObject.type === 'CHECK_PASSWORD') {
                    const data = jsonObject.param
                    const resultType = data.result
                    const auth = data.authType
                    const page = data.page
                    const password = data.password

                    if (page === "barcode") {
                        if (resultType === '00') {
                            console.log('passwordBarcode ')
                            const event = new CustomEvent('passwordBarcode', { detail: { password: password } });
                            window.dispatchEvent(event)
                        } else {
                            const event = new CustomEvent('failPassword', { detail: { resultType: resultType } });
                            window.dispatchEvent(event)
                        }
                    }
                    if (page === "barcodeTerm") {
                        if (resultType === '00') {
                            const event = new CustomEvent('passwordBarcodeTerm', { detail: { password: password } });
                            window.dispatchEvent(event)
                        } else {
                            const event = new CustomEvent('failPassword', { detail: { resultType: resultType } });
                            window.dispatchEvent(event)
                        }
                    }
                    if (page === "paymentLimit") { // 한도 변경에서 사용
                    }
                    if (page === 'paymentLimit/term') {
                        if (resultType === '00') {
                        }
                    }
                    if (page === 'mobile-pay/setting|payBlock') {
                    }
                    if (page === 'mobile-pay/setting|autoPayBlock') {
                    }
                    if (page === 'paymentSetting/payBlockTerm') {
                    }
                    if (page === 'paymentSetting/autoPayBlockTerm') {
                    }
                    if (page.startsWith('paymentRequest')) {
                        const otpId = page.split('-')[1]
                        const paySeq = await paymentApi.getPaySeq('v1')
                        if (paySeq.header.resultCode === "0000") {
                            const payConfirm = await paymentApi.postPayConfirm({
                                otpId: otpId,
                                encSeq: paySeq.body.encSeq,
                                passwordSha: password,
                                appResult: '00',
                                authType: '01'
                            }, 'v1')
                            if (paySeq.header.resultCode === "0000") {
                                setPasswordErrorPopup({ message: "거래완료", show: true })
                            }
                        } else {
                            setPasswordErrorPopup({
                                message: paySeq.header.resultCode + paySeq.header.message,
                                show: true
                            })
                        }
                    }
                    if (page === "modifyInfo") {
                        if (resultType === '00') {
                        }
                    }
                }

                if (jsonObject.type === 'PASSWORD') {
                    const data = jsonObject.param
                    const password = data.password
                    const page = data.page

                    if (page.startsWith('paymentRequest')) {
                        // 휴대폰 결제 취소시 호출한다.
                        const otpId = page.split('-')[1]
                        const paySeq = await paymentApi.getPaySeq('v1')
                        if (paySeq.header.resultCode === "0000") {
                            const payConfirm = await paymentApi.postPayConfirm({
                                otpId: otpId,
                                encSeq: paySeq.body.encSeq,
                                passwordSha: password,
                                appResult: '01',
                                authType: '00'
                            }, 'v1')
                            if (paySeq.header.resultCode === "0000") {
                                setPasswordErrorPopup({ message: "취소완료", show: true })
                            }
                        } else {
                            setPasswordErrorPopup({
                                message: paySeq.header.resultCode + paySeq.header.message,
                                show: true
                            })
                        }
                    }
                }

                if (jsonObject.type === 'CALL_LOGIN') {
                    const data = jsonObject.param
                    switch (data.rt) {
                        case '00000':
                            const fetchDas = async () => {
                                try {
                                    const tcpTrKey = await generateMCP_TR_KEY();
                                    const res = await otherApi.getDas({
                                        ssoKey: data.sso,
                                        lgId: data.userId
                                    }, 'v1', tcpTrKey);
                                    if (res.header.resultCode === '0000') {
                                        const name = await decrypt(tcpTrKey, res.body.name);
                                        const ctn = res.body.ctn;
                                        const info = {
                                            name: name,
                                            birthday: res.body.birthday,
                                            gender: res.body.gender,
                                            nation: res.body.nation,
                                            telcoCode: res.body.carrier,
                                            phoneNo: ctn.length === 12 ? ctn.slice(0, 3) + ctn.slice(4) : ctn,
                                            userCI: res.body.ci,
                                            dasKey: res.body.dasKey,
                                            dasSsoKey: res.body.dasSsoKey,
                                        }

                                        if (info.dasKey) { // myLg 회원가입 시 개인정보가 잘못내려오는 경우
                                            const platform = await getItemByKey('platform');
                                            if (platform !== 'IOS' && platform !== 'ios') {
                                                const telcoCode = await getItemByKey('telcoCode');
                                                const ctn = await getItemByKey('ctn');
                                                if (info.telcoCode !== telcoCode || res.body.ctn !== ctn) {
                                                    return;
                                                }
                                            }
                                        }

                                        await addItem('loginType', 'MYLGID');
                                        await addItem('signupDate', timeFormat(new Date()));
                                        navigate('/agreements/join', { state: info });
                                    } else {
                                        setMyLgIdPopup(true);
                                    }
                                } catch (error) {
                                    console.log('Error fetching DAS API:', error);
                                    setMyLgIdPopup(true);
                                }
                            }
                            fetchDas();
                            break;
                        case '00014': // 14세 미만
                        default:
                            setMyLgIdPopup(true);
                            break;
                    }
                }

                if (jsonObject.type === 'CALL_CERTIFICATION') {
                    const data = jsonObject.param
                    if (data && data.target === 'certification' && data.isMember) {
                        navigate('/phone-certification?target=app')
                    }
                    if (data && data.target === 'certification' && !data.isMember) {
                        navigate('/phone-certification?target=web')
                    }
                }

                if (jsonObject.type === 'LANDING_PAGE') {
                    const data = jsonObject.param
                    console.log('LANDING_PAGE data : ', data)

                    if (data.targetUrl === 'mobile-pay/request') {
                        if (FeatureFlag.FADE_OUT_2) {
                            return;
                        }

                        const response = await paymentApi.getPayRequest({}, 'v1')
                        if (response.header.resultCode === "0000") {
                            const data = response.body
                            setMobilePayRequestPopup({
                                show: true,
                                payShopName: data.payShopName,
                                payMoney: data.payMoney,
                                otpId: data.otpId
                            })
                        } else {
                        }
                        return;
                    }

                    let urlParam = '';
                    if (data.utm_medium !== '') {
                        urlParam += 'utm_medium=' + data.utm_medium + '&';
                    }
                    if (data.utm_source !== '') {
                        await addItem('utmSource', data.utm_source);
                        urlParam += 'utm_source=' + data.utm_source + '&';
                    }
                    if (data.utm_campaign !== '') {
                        urlParam += 'utm_campaign=' + data.utm_campaign + '&';
                    }
                    if (data.utm_term !== '') {
                        urlParam += 'utm_term=' + data.utm_term + '&';
                    }
                    if (data.utm_content !== '') {
                        await addItem('utmContent', data.utm_content);
                        urlParam += 'utm_content=' + data.utm_content + '&';
                    }
                    if (urlParam.length > 0) {
                        urlParam = urlParam.slice(0, -1);
                    }
                    let tmpParam = data.targetParam || ''
                }

                if (jsonObject.type === 'FCM_TOKEN') {
                    const data = jsonObject.param
                }
                if (jsonObject.type === 'REFRESH_TOKEN') {
                    const data = jsonObject.param
                    if (await getItemByKey('memberId')) {
                        await addItem('pushRegId', data.newToken)
                        const response = await settingApi.putPushReg({ pushRegId: data.newToken }, 'v1');
                        if (response.header.resultCode === '0000') {
                            await addItem('sendTokenYn', 'Y')
                        } else {
                            await addItem('sendTokenYn', 'N')
                        }
                    }
                }
                if (jsonObject.type === 'ACTION_EVENT') {
                    const data = jsonObject.param
                    if (data.action === 'resume') {
                        console.log('ACTION_EVENT resume');
                        if (FeatureFlag.RESUME_RELOAD_TIME) {
                            const lastedReloadTime = await idbUtil.getLatestAppStartTime();
                            if (lastedReloadTime) {
                                const now = new Date();
                                const diff = now.getTime() - lastedReloadTime.getTime();
                                console.log(`App reloaded after ${diff} milliseconds`);

                                const isReload = diff >= FeatureFlag.RESUME_RELOAD_TIME;
                                if (isReload) {
                                    await idbUtil.setLatestAppStartTime();
                                    await idbUtil.delLatestNavigateTabTime();
                                    navigate('/');
                                    window.location.reload();
                                    return;
                                }
                            }
                        }

                        const latestNavigateTabTime = await idbUtil.getLatestNavigateTabTime();
                        if (latestNavigateTabTime) {
                            idbUtil.delLatestNavigateTabTime();
                            navigate('/');
                            window.location.reload();
                            return;
                        }

                        const mcpTrKey = generateMCP_TR_KEY()
                        const responseAuth = await fetchAuth(mcpTrKey);
                        const token = responseAuth.body.token;
                        await addItem('sessionKey', token);
                        const platform = await getItemByKey('platform');
                        handleSendEvent(platform, 'SET_AUTHORIZATION', {
                            authorization: `${token}`,
                        });

                        const event = new CustomEvent('resume', { detail: {} });
                        window.dispatchEvent(event)

                        console.log(`resume navigate : ${window.location.pathname + window.location.search}`);
                        navigate(window.location.pathname + window.location.search, { replace: true });
                    }
                }

                if (jsonObject.type === 'WAITING_LINE_POPUP') {
                    const data = jsonObject.param
                    if (data.result === '00') {

                    } else if (data.result === '01') {

                    }
                }

                if (jsonObject.type === 'GET_GRANT_LOCATION') {
                    const data = jsonObject.param
                    const ptnId = data.ptnId;
                    if (data.agree) {
                        if (ptnId) {
                            navigate('/map', { state: { ptnId: ptnId } });
                        } else {
                            navigate('/map');
                        }
                    } else {
                        const event = new CustomEvent('triggerGpsPopup');
                        window.dispatchEvent(event)
                    }

                }
                if (jsonObject.type === 'CALL_LOCATION_POPUP') {
                    // 동의 여부와 상관없이 /map 으로 보냄. 현재 위치 못받아오면 default 위치 보여줌
                    const ptnId = jsonObject.param.ptnId;
                    if (ptnId) {
                        navigate('/map', { state: { ptnId: ptnId } });
                    } else {
                        navigate('/map');
                    }
                }

                if (jsonObject.type === 'RESET_LOGIN_INFO') {
                }

                if (jsonObject.type === 'OPEN_NOTIFICATION') {
                    const data = jsonObject.param
                }

                if (jsonObject.type === 'GET_NOTIFICATION') {
                    const data = jsonObject.param
                }

                if (jsonObject.type === 'IPIN_RESULT') {
                    const data = jsonObject.param

                    const name = await decrypt(data.MCP_TR_KEY, data.Name);
                    const birth = await decrypt(data.MCP_TR_KEY, data.Birth);

                    const resultObj: any = {
                        ipinAuthId: data.IPINAuthNum,
                        name: name,
                        birthday: birth,
                        gender: data.Gender,
                        nation: data.Nation,
                        code: data.Code,
                    };

                }

                if (jsonObject.type === 'WAITING_LINE_POPUP') {
                    const data = jsonObject.param
                    const target = data.target;
                    if (data.result === '00') { // 대기열 성공
                        if (target === 'detail') {
                            navigate(`/uptp-detail/${data.id}`);
                            return;
                        }


                        // if (homeBenefitPopupRef.current) {
                        //     homeBenefitPopupRef.current.waitingPopupSuccess(data.id);
                        // }
                        // if (uptpRef.current) {
                        //     uptpRef.current.waitingPopupSuccess(data.id);
                        // }
                    }
                }

                if (jsonObject.type === 'CLOSE_NOTI') {
                }

            } catch (error) {
                console.log('web : JSON parsing error:', error);
            }
        };

        // (window as any).onExecuteCallback(JSON.stringify({ action: 'keypress', detail: 'back' }));

        return () => {
            delete (window as any).onExecuteCallback;
        };

    }, []);

    useEffect(() => {
        const startApp = async () => {
            await initDB();
            await idbUtil.setLatestAppStartTime();
            await idbUtil.delLatestNavigateTabTime();
            await sendEventReturn('INITIAL_LOADING_FINISHED', {});
        }
        startApp()

    }, []);

    return (
        <>
        <GlobalStyle />
        <div className='app-container'>
            <div className='main-content'>
                <ScrollToTop />
                <Routes>
                    <Route path='/index.html' element={
                            <FOHomeBenefitPopup />
                    } />
                    <Route path='/' element={
                            <FOHomeBenefitPopup />
                    } />
                </Routes>
            </div>
        </div>
        </>
    );
};

export default App;
